module.exports = __webpack_public_path__ + "static/aboutus-5.096fc30b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutus/aboutus-5.svg
// module id = 108
// module chunks = 168707334958949